export default function OR() {
  return (
    <div className="p-4">
      <h1>OR</h1>
    </div>
  );
}
